module.exports = __webpack_public_path__ + "img/standard.d8c08fd8.png";